import React, { Component, PropTypes } from 'react';
import register from './../register/register.js';

class RegisterDetails extends Component {
	componentWillMount() {
		register().open('register_details');
	}

	componentWillUnmount() {
		if (window.location.pathname === '/register') {
			register().open('register');
		} else {
			register().close();
		}
	}

	render() {
		return (
			<div id="register-details" />
		);
	}
}

RegisterDetails.propTypes = {
	router: PropTypes.object
};

export default RegisterDetails;



// WEBPACK FOOTER //
// ./mobile-core/src/components/register-details.js